import InitialState from './AdditionalServiceInitialState'

import listReducer from './list/additionalServiceListReducer'

const initialState = new InitialState()

export default function additionalServiceReducer(state = initialState, action) {
    let nextState = state

    const list = listReducer(state.list, action)
    if (list !== state.list) nextState = nextState.setIn(['list'], list)

    return nextState
}


